module.exports = __webpack_public_path__ + "pf.svg?b6f47989b5c69e0ab2ed87e26869a342";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/pf.svg
// module id = 1558
// module chunks = 0